import { useState,useEffect, useRef } from "react";
import { useNavigate } from "react-router-dom";
import { Container, Row, Col } from "react-bootstrap";
import "../visitor/visitor-view/visitor-view.css";
import ModalCloseIcon from "../../assets/svg/close-modal.svg";
import info from "../../assets/svg/info.svg";
import { scheduleStatusUpdateApi } from "../visitor/visitor-api";

 const UpdateScheduleStatusModal = ({visitorId,onSuccess,onCancel }) => {
    const apiUrl = process.env.REACT_APP_API_URL;
    const navigate = useNavigate();
    const [errorMessage, setErrorMessage] = useState("");
    const modalStyle = {
        overlay: {
          position: "fixed",
          top: 0,
          left: 0,
          right: 0,
          bottom: 0,
          backgroundColor: "rgba(0, 0, 0, 0.5)",
          opacity: 1,
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          zIndex: 1000,
        },
        modal: {
          backgroundColor: "#ffffff",          
          
          borderRadius: "16px",
          boxShadow: "0 4px 6px rgba(0, 0, 0, 0.1)",
          width: "680px",
          
          overflowY: "auto",
        },
      };
      useEffect(() => {
       
    },[]) 
    const [selectedStatus, setSelectedStatus] = useState('pending'); 
    const [rejectReason, setRejectReason] = useState(''); 
    const [scheduleDate, setScheduleDate] = useState("");
    const [scheduleTime, setScheduleTime] = useState("");

    const handleChange = (event) => {
      setSelectedStatus(event.target.value);
    };

        const scheduleStatusUpdate = async () => {
                 
                 const payload = {
                    "visitor_id": visitorId,
                     "schedule_status": selectedStatus==='approve'?'Approved': (selectedStatus==='reject'?'Reject':(selectedStatus==='datemodifi'?'datemodi':'pending')),
                     "remark":rejectReason,
                     "in_time": scheduleDate+" "+scheduleTime
                    
                  };
                  try {
                    const response = await scheduleStatusUpdateApi(payload);
                    if (response.statusCode === 400) {}
                    else{
                          if(response.data.status===true){                           
                            onSuccess(response.data)
                          }else{
                                 
                                }
                    }
                return response.data;
                  } catch (err) {
                    console.error("Error fetching category:", err);
                  } finally {
                  }
                };


    return ( <div style={modalStyle.overlay}>
        <div style={modalStyle.modal}>
          <div style={{ color: "#ffffff" }}>
            <div>
            <div className="modal-header style-justify-between"
            >
              <div className="modal-title"
    >
    Update scheduled status
    </div>
    <img
                              src={ModalCloseIcon}
                              alt="Close"
                              onClick={onCancel}
                              style={{ cursor: "pointer",width: "30px", height: "30px", borderRadius: "50%" }}
                            />
      
            </div>
            <div className="px-3 py-3">
   <div className="style-justify-center" style={{gap:'8px'}}>
   <label className={`${selectedStatus === 'pending'?'radio-btn-txt-active':'radio-btn-txt-inactive'}`} >
        <input
          type="radio"
          name="options"
          value="pending"
          checked={selectedStatus === 'pending'}
          onChange={handleChange}
          className="custom-radio"
        />
        <span className={`px-2 ${selectedStatus === 'pending'?'radio-btn-txt-active':'radio-btn-txt-inactive'}`}>Pending</span>
  </label>

  <label className={`${selectedStatus === 'approve'?'radio-btn-txt-active':'radio-btn-txt-inactive'}`}>
        <input
          type="radio"
          name="options"
          value="approve"
          checked={selectedStatus === 'approve'}
          onChange={handleChange}
          className="custom-radio"
        />
        <span className={`px-2 ${selectedStatus === 'approve'?'radio-btn-txt-active':'radio-btn-txt-inactive'}`}>Approve</span>
  </label>

  <label  className={`${selectedStatus === 'reject'?'radio-btn-txt-active':'radio-btn-txt-inactive'}`}>
        <input
          type="radio"
          name="options"
          value="reject"
          checked={selectedStatus === 'reject'}
          onChange={handleChange}
          className="custom-radio"
        />
        <span className={`px-2 ${selectedStatus === 'reject'?'radio-btn-txt-active':'radio-btn-txt-inactive'}`}>Reject</span>
  </label>

  <label  className={`${selectedStatus === 'datemodifi'?'radio-btn-txt-active':'radio-btn-txt-inactive'}`}>
        <input
          type="radio"
          name="options"
          value="datemodifi"
          checked={selectedStatus === 'datemodifi'}
          onChange={handleChange}
          className="custom-radio"
        />
        <span className={`px-2 ${selectedStatus === 'datemodifi'?'radio-btn-txt-active':'radio-btn-txt-inactive'}`}>Date Modification</span>
  </label>


   </div>
   {selectedStatus === 'pending' && (<div className="mt-2">
     <img src={info} alt=""/> <span className="info-text">Select any status to update the status of this visitor</span>
   </div>)}
{selectedStatus === 'approve' && (
   <div className="style-justify-center mt-3">
      <div className="approve-card"> 
        <div className="approve-card-txt">Are you sure want to approve this visitor?</div>
        <div className="style-justify-center mt-3" style={{gap:'8px'}}>
         {/*  <div className="schedule-approve-cancel-btn px-3">
          No, Don’t approve
          </div> */}
          <div onClick={()=>{scheduleStatusUpdate()}} className="schedule-approve-btn px-3">
          Yes, Approve & Submit
          </div>
        </div>
      </div>
   </div>)}

   {selectedStatus === 'reject' && (<div>
<div className="field-title mb-1">Remarks of rejection</div> 
                                                  <div>
                        <textarea
                          type="text"
                          placeholder=" "
                          className="input-field w-100"
                          value={rejectReason}
                          onChange={(event) => {
                            setRejectReason(event.target.value); // Update state with input value
                          }}
                        />
                         {/* <span className="field-error">{validations.reason}</span> */}
                      </div>
                   
</div>)}
{selectedStatus === 'datemodifi' && (<div>
<div className="approve-card-txt mb-1">Schedule timing</div> 
                    <Row className="mt-1">
                      <Col sm={7} >
                      <div className="field-title mb-1">Date</div> 
                      <div>
                          <input
                            type="date"
                            placeholder="Enter here"
                            className="input-field w-100"
                            min={new Date().toISOString().split('T')[0]}
                            value={scheduleDate}
                            onChange={(event) => {                            
                              setScheduleDate(event.target.value);
                            }}
                          />
                        </div> 
                      </Col>
                      <Col sm={5} className="px-0" >
                      <div className="field-title mb-1">Time</div> 
                      <div>
                          <input
                            type="time"
                            placeholder="Enter here"
                            className="input-field w-100"
                            value={scheduleTime}
                            onChange={(event) => {                            
                              setScheduleTime(event.target.value);
                            }}
                          />
                        </div> 
                      </Col>
                        
                        {/* <span style={{display: "flex", alignItems: "center", justifyContent: "start",fontSize: "12px",fontWeight: 400,color: "#FF4444", }}>{validations.in_time}</span>  */}                     
                      </Row>
</div>)}
{(selectedStatus === 'reject' || selectedStatus === 'datemodifi') && (<Row className="mt-3"                
              >
                <div className="style-justify-end">
                <div
                  onClick={onCancel} className="admin-checklist-cancel-btn style-justify-center"                  
                >
                 Cancel
                </div>

               <div
                   onClick={()=>{scheduleStatusUpdate()}}  className="schedule-approve-btn style-justify-center px-5"                  
                >
                 Approve
                </div>
                </div>
              </Row>)}
   </div>
            </div>

          
          </div>
        </div>
      </div>);

}

export default UpdateScheduleStatusModal;